import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] py-10 px-4 text-center text-gray-500 text-sm border-t border-gray-900 mt-16" data-id="element-57">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-58">
        <p className="font-medium" data-id="element-59">
          © {new Date().getFullYear()} Método Control Total. Todos los derechos
          reservados.
        </p>
        <p className="text-xs leading-relaxed max-w-3xl mx-auto" data-id="element-60">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}